export default __webpack_public_path__ + "static/media/9_rate_gain.d03b3e78.svg";